<template>
  <div class="mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione una razón"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
              disabled
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerAddTransferRequest"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import CustomDropDown from "custom-drop-down";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import objectToFormData from "object-to-formdata";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import service from "@/services/api/inventoryOrderBooks.api";
import ReasonTypes from "@/utils/constants/inventory/reasonTypes";
import Reasons from "@/utils/constants/inventory/inventoryOrderBookTransferReasons";

export default {
  name: "TransferRequest",
  components: {
    ActionButton,
    CustomDropDown
  },
  mixins: [alertMixin],
  props: {
    equipment: {
      type: Object,
      required: true
    },
    recommendation: {
      type: Object
    },
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      reasons: [],
      model: {
        reason: null
      }
    };
  },
  async mounted() {
    await this.getReasons();
  },
  methods: {
    downloadFile() {},
    async handlerAddTransferRequest() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea crear la solicitud de transferencia?`,
        "Sí",
        "No"
      );

      if (!isConfirmed) {
        return;
      }

      this.saveTransferRequest();
    },
    saveTransferRequest() {
      const payload = objectToFormData({
        reasonId: this.model.reason?.id,
        bookId: this.equipment.id,
        centerIdTo: this.order?.center.id,
        orderDetailId: this.order?.id
      });
      service
        .transfer(payload)
        .then(() => {
          this.ShowToast(
            "Éxito",
            "La solicitud se ha realizado exitosamente.",
            "success"
          );
          this.model = {
            reason: null
          };
          this.$emit("close");
        })
        .catch(error => {
          this.ShowToast("Error", error?.response?.data.message, "error");
        });
    },
    async getReasons() {
      const { data } = await inventoryCatalogService.getReasonsByType(
        ReasonTypes.MissingAppointmentsWithoutExcuses
      );
      this.reasons = data;
      const reason = data.find(x => x.id === Reasons.NotAvailableInCenter);
      if (reason) this.model.reason = reason;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
